"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_PRODUCTS = exports.SAVE_ADMIN_SETUP = exports.FAIL = exports.SUCCESS = exports.START = void 0;
exports.START = '_START';
exports.SUCCESS = '_SUCCESS';
exports.FAIL = '_FAIL';
exports.SAVE_ADMIN_SETUP = 'SAVE_ADMIN_SETUP';
exports.UPDATE_PRODUCTS = 'UPDATE_PRODUCTS';
